/* OCTAGON - "Zuletzt angesehen" na karcie produktu.

   Rama i naglowek KLONOWANE z natywnej sekcji polecanych produktow
   (product-recommendations), zeby obie karty wygladaly identycznie -
   [stated] Dawid: "Karta DAS KOENNTE DIR AUCH GEFALLEN i zuletzt gesehen
   nie sa takie same, wygladaja roznie".
   Punkt zaczepienia: [data-testid="product-list"] ALBO
   [data-testid="product-recommendations-section"] .section-resource-list.

   !!! WSZYSTKIE NAPISY Z window.OCT_I18N (trzy jezyki). Dotyczy tytulu
   sekcji ORAZ PLAKIETEK. Plakietki buduje ten plik WLASNYM kodem,
   rownolegle do snippets/octagon-tag-badges.liquid - PRZY KAZDEJ ZMIANIE
   PLAKIETEK POPRAWIAC OBA MIEJSCA. Same TAGI zostaja po niemiecku,
   bo stoja na nich reguly kolekcji; tlumaczy sie tylko napis.

   !!! PREFIKS JEZYKA W ADRESACH (12.08.2026).
   [stated] Dawid: "Jak mam ustawiony de i it (...) z automatu zmienia
   strone na de!". Adres "/products/..." bez prefiksu to dla Shopify
   jezyk DOMYSLNY. Dlatego KAZDY adres i KAZDE zapytanie idzie przez R().
   Ma to drugi, wazniejszy skutek: zapytanie /fr/products/<handle>.js
   zwraca PRZETLUMACZONY tytul produktu. Bez prefiksu kafelki pokazywaly
   niemieckie nazwy na francuskiej wersji sklepu.

   Zero ingerencji w layout/theme.liquid. W localStorage same uchwyty.
   Wylacznik: OCT_RECENT_ON = false. */
(function () {
  'use strict';

  var OCT_RECENT_ON = true;
  var KEY = 'octRecent';
  var MAX_STORE = 12;
  var MAX_SHOW = 4;
  var REF_SELECTOR = '[data-testid="product-list"], [data-testid="product-recommendations-section"] .section-resource-list';

  if (!OCT_RECENT_ON) return;

  /* Korzen biezacego jezyka: "/" na glownym, "/fr/" na francuskim. */
  function R() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }

  function tx(k, fb) {
    return (window.OCT_I18N && window.OCT_I18N[k]) || fb;
  }

  function title() {
    return tx('recent', 'Zuletzt angesehen');
  }

  function currentHandle() {
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Object.prototype.toString.call(arr) === '[object Array]' ? arr : [];
    } catch (e) { return []; }
  }

  function save(list) {
    try { window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX_STORE))); } catch (e) {}
  }

  function remember(handle) {
    var list = read().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    save(list);
  }

  function sized(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function money(cents) {
    return 'CHF ' + (cents / 100).toFixed(2);
  }

  /* Plakietki 1:1 wg regul z snippets/octagon-tag-badges.liquid.
     Warunki chodza po TAGACH (niemieckich), napisy z OCT_I18N. */
  function badges(p) {
    var tags = (p.tags || []).map(function (t) { return String(t).toUpperCase(); });
    function has(part) {
      for (var i = 0; i < tags.length; i++) { if (tags[i].indexOf(part) !== -1) return true; }
      return false;
    }
    var neu = tags.indexOf('NEU') !== -1;
    var limited = has('LIMITED');
    var last = has('LETZTE');
    var best = has('BESTSELLER');
    var shadow = has('SHADOW EDITION');
    var leather = has('ECHTLEDER');
    var percent = 0;
    if (p.compare_at_price && p.price && p.compare_at_price > p.price) {
      percent = Math.round((p.compare_at_price - p.price) * 100 / p.compare_at_price);
    }
    if (!(neu || limited || last || best || shadow || leather || percent > 0)) return '';

    var html = '';
    if (shadow)  html += '<span class="oct-badge oct-badge--shadow">' + tx('badge_shadow', 'SHADOW EDITION') + '</span>';
    if (neu)     html += '<span class="oct-badge oct-badge--neu">' + tx('badge_neu', 'NEU') + '</span>';
    if (limited) html += '<span class="oct-badge oct-badge--limited">' + tx('badge_limited', 'LIMITED') + '</span>';
    if (leather) html += '<span class="oct-badge oct-badge--leather">' + tx('badge_leather', 'ECHTLEDER') + '</span>';
    if (last)    html += '<span class="oct-badge oct-badge--last">' + tx('badge_last', 'LETZTE ST\u00dcCKE') + '</span>';
    if (best)    html += '<span class="oct-badge oct-badge--best">' + tx('badge_best', 'BESTSELLER') + '</span>';
    if (percent > 0) html += '<span class="oct-badge oct-badge--sale">-' + percent + '%</span>';
    return '<div class="oct-badges">' + html + '</div>';
  }

  function card(p) {
    var a = document.createElement('a');
    a.className = 'oct-recent__card';
    a.href = R() + 'products/' + p.handle;

    var media = '<div class="oct-recent__media">';
    if (p.featured_image) {
      media += '<img src="' + sized(p.featured_image, 500) + '" alt="" loading="lazy" decoding="async">';
    }
    media += '</div>';

    a.innerHTML = badges(p) + media +
      '<p class="oct-recent__name"></p>' +
      '<p class="oct-recent__price">' + money(p.price) + '</p>';
    a.querySelector('.oct-recent__name').textContent = p.title;
    return a;
  }

  function shell() {
    var ref = document.querySelector(REF_SELECTOR);
    var box = document.createElement('div');

    if (ref) {
      box.className = ref.className;
      var st = ref.getAttribute('style');
      if (st) box.setAttribute('style', st);
      box.classList.add('oct-recent');

      var head = ref.querySelector('.section-resource-list__header') ||
                 ref.querySelector('.section-resource-list__content');
      if (head) {
        var clone = head.cloneNode(true);
        var links = clone.querySelectorAll('a, button');
        for (var i = 0; i < links.length; i++) { links[i].parentNode.removeChild(links[i]); }
        var h = clone.querySelector('h1, h2, h3, h4, h5, h6, p');
        if (h) { h.textContent = title(); }
        box.appendChild(clone);
      }
    } else {
      box.className = 'oct-recent oct-recent--standalone';
      var fallback = document.createElement('h2');
      fallback.className = 'oct-recent__title';
      fallback.textContent = title();
      box.appendChild(fallback);
    }

    var grid = document.createElement('div');
    grid.className = 'oct-recent__grid';
    box.appendChild(grid);
    return { box: box, grid: grid, ref: ref };
  }

  function render(products) {
    if (!products.length || document.querySelector('.oct-recent')) return;
    var main = document.getElementById('MainContent');
    if (!main) return;

    var s = shell();
    products.forEach(function (p) { s.grid.appendChild(card(p)); });

    var anchor = s.ref ? s.ref.closest('.shopify-section') : null;
    if (anchor && anchor.parentNode) {
      anchor.parentNode.insertBefore(s.box, anchor.nextSibling);
    } else {
      main.appendChild(s.box);
    }
  }

  function boot() {
    var handle = currentHandle();
    if (!handle) return;

    var list = read().filter(function (h) { return h !== handle; }).slice(0, MAX_SHOW);
    remember(handle);
    if (!list.length) return;

    Promise.all(list.map(function (h) {
      return fetch(R() + 'products/' + h + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (results) {
      var ok = results.filter(function (p) { return p && p.handle; });
      render(ok);
      if (ok.length !== list.length) {
        var alive = ok.map(function (p) { return p.handle; });
        save(read().filter(function (h) { return list.indexOf(h) === -1 || alive.indexOf(h) > -1; }));
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
